import { FunctionComponent } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { TextField } from '@mui/material';
import { CreateTransactionModalFormModel } from '../CreateTransactionModal/CreateTransactionModalFormModel';
import { useTranslation } from '@/lib';

interface TransactionDocumentNumberFieldProps {
  control: Control<CreateTransactionModalFormModel>;
  errors: FieldErrors<CreateTransactionModalFormModel>;
  disabled?: boolean;
}

export const TransactionDocumentNumberField: FunctionComponent<TransactionDocumentNumberFieldProps> = ({ control, errors, disabled }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="documentNumber"
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          label={t('document_number')}
          error={errors.documentNumber !== undefined}
          helperText={errors.documentNumber?.message}
          disabled={disabled}
        />
      )}
    />
  );
};
